import React, { useEffect, useState } from "react";
import { StudentDashboard } from "@modules/admin";
import { LayoutStudent } from "@unisearch/theme/layout";

const Dashboard = () => {
  return (
    <LayoutStudent title="Student | Dashboard" pageTitle="Dashboard">
      <StudentDashboard />
    </LayoutStudent>
  );
};

export default Dashboard;
